import axios from 'axios';
import { logger } from '@fiverr-private/obs';
import pathfinder from '@fiverr-private/pathfinder';
import { UserContext } from './types';

const URL = pathfinder('business_api_lean_user_context');

export const getUserContext = async ({ source }: { source?: string }): Promise<UserContext> => {
    try {
        const data = await axios.get<UserContext>(URL);

        return data.data;
    } catch (error) {
        logger.error(error as Error, {
            description: `Failed to fetch pro user context${source ? `, source: ${source}` : ''}`,
        });
        throw error;
    }
};
